import type { Content } from '#types/content'
import type { ModulesConfig } from '#types/mappings'

/**
 * Looks up the Vue component (and hydration strategy / options) registered for a CMS content
 * node's `type` and resolves the variant override when one is configured. Returns `undefined`
 * when the node's `type` is not registered in `mappings`.
 * @param content - The CMS content node.
 * @param mappings - The content-type → component / hydration registry.
 * @returns The original `content` augmented with the resolved `componentType`, `hydration`, and
 *          `hydrationOptions`, or `undefined` when the type is unmapped.
 * @category Utils
 */
export const resolveContentComponent = (content: Content, mappings: ModulesConfig) => {
  const config = mappings[content?.type]

  if (!config)
    return

  let { hydration, hydrationOptions, component, variants } = config

  if (variants) {
    const variant = variants[content.variant!] || variants.default
    component = variant.component
    hydration = variant.hydration || hydration
    hydrationOptions = variant.hydrationOptions || hydrationOptions
  }

  return { ...content, componentType: component, hydration, hydrationOptions }
}
